import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState } from "react";
const HoverOverlayContext = createContext(null);
export function HoverOverlayProvider({ children }) {
    // ref-count so multiple hover sources don't flicker
    const [count, setCount] = useState(0);
    const show = useCallback(() => setCount((c) => c + 1), []);
    const hide = useCallback(() => setCount((c) => Math.max(0, c - 1)), []);
    const value = useMemo(() => ({ active: count > 0, show, hide }), [count, show, hide]);
    return (_jsx(HoverOverlayContext.Provider, { value: value, children: children }));
}
export function useHoverOverlay() {
    const ctx = useContext(HoverOverlayContext);
    if (!ctx)
        throw new Error("useHoverOverlay must be used inside HoverOverlayProvider");
    return ctx;
}
/** Convenience: bind onMouseEnter/onMouseLeave quickly */
export function useOverlayHoverHandlers() {
    const { show, hide } = useHoverOverlay();
    return useMemo(() => ({ onMouseEnter: show, onMouseLeave: hide }), [show, hide]);
}
